import { useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { segmentsQueryKeys } from "./queryKeys";

import type { SegmentActivity } from "@/features/segments/types";
import { instance } from "@/lib/axios/instance";

type UseSegmentActivityParams = {
  segmentId?: string;
  clientId?: string;
};

export function useSegmentActivity({ segmentId, clientId }: UseSegmentActivityParams) {
  return useQuery<SegmentActivity[], AxiosError>({
    queryKey: segmentsQueryKeys.activity(segmentId),
    queryFn: () =>
      instance
        .get<SegmentActivity[]>(`/api/v2/Segments/${segmentId}/activity`, {
          params: clientId ? { clientId } : {},
        })
        .then((res) => res.data),
    enabled: Boolean(segmentId),
    refetchOnMount: true, // Overrides the global false so a `segment:*` realtime invalidation (api/realtime.ts) refetches on return
  });
}